import axios from "axios";
import { API_GET_ATTRIBUTES_BY_PRODUCT_DATA, API_GET_ATTRIBUTES_DATA, API_GET_COLORS_DATA, API_GET_FINISHES_DATA, API_GET_MATERIALS_DATA, API_GET_SIZES_DATA, API_GET_STORAGES_DATA, API_INSERT_ATTRIBUTE_DATA, API_INSERT_COLOR_DATA, API_INSERT_FINISH_DATA, API_INSERT_MATERIAL_DATA, API_INSERT_SIZE_DATA, API_INSERT_STORAGE_DATA, API_TOGGLE_ATTRIBUTE_DATA, API_UPDATE_ATTRIBUTE_DATA, API_UPDATE_COLOR_DATA, API_UPDATE_FINISH_DATA, API_UPDATE_MATERIAL_DATA, API_UPDATE_SIZE_DATA, API_UPDATE_STORAGE_DATA } from ".";

export const getAttributesList = async (func, config) => {
    return axios.get(API_GET_ATTRIBUTES_DATA, config).then(res => func(res.data.data))
}

export const getAttributesByProductData = async (data, config) => {
    return axios.put(API_GET_ATTRIBUTES_BY_PRODUCT_DATA, data, config).then((res) => res.data);
};

export const insertAttributeData = async (data, config) => {
    return axios.post(API_INSERT_ATTRIBUTE_DATA, data, config).then((res) => res.data);
};

export const updateAttributeData = async (data, config) => {
    return axios.put(API_UPDATE_ATTRIBUTE_DATA, data, config).then((res) => res.data);
};

export const toggleAttributeData = async (data, config, cb) => {
    return axios.put(API_TOGGLE_ATTRIBUTE_DATA, data, config).then((res) => {
        if (res.data.status === "success") {
            cb();
        };
    });
};



export const getFinishesList = async (func, config) => {
    return axios.get(API_GET_FINISHES_DATA, config).then(res => func(res.data.data));
};

export const insertFinishData = async (data, config) => {
    return axios.post(API_INSERT_FINISH_DATA, data, config).then((res) => res.data);
};

export const updateFinishData = async (data, config) => {
    return axios.put(API_UPDATE_FINISH_DATA, data, config).then((res) => res.data);
};



export const getSizesList = async (func, config) => {
    return axios.get(API_GET_SIZES_DATA, config).then(res => func(res.data.data));
};

export const insertSizeData = async (data, config) => {
    return axios.post(API_INSERT_SIZE_DATA, data, config).then((res) => res.data);
};

export const updateSizeData = async (data, config) => {
    return axios.put(API_UPDATE_SIZE_DATA, data, config).then((res) => res.data);
};



export const getStoragesList = async (func, config) => {
    return axios.get(API_GET_STORAGES_DATA, config).then(res => func(res.data.data));
};

export const insertStorageData = async (data, config) => {
    return axios.post(API_INSERT_STORAGE_DATA, data, config).then((res) => res.data);
};

export const updateStorageData = async (data, config) => {
    return axios.put(API_UPDATE_STORAGE_DATA, data, config).then((res) => res.data);
};



export const getColorsList = async (func, config) => {
    return axios.get(API_GET_COLORS_DATA, config).then(res => func(res.data.data));
};

export const insertColorData = async (data, config) => {
    return axios.post(API_INSERT_COLOR_DATA, data, config).then((res) => res.data);
};

export const updateColorData = async (data, config) => {
    return axios.put(API_UPDATE_COLOR_DATA, data, config).then((res) => res.data);
};



export const getMaterialsList = async (func, config) => {
    return axios.get(API_GET_MATERIALS_DATA, config).then(res => func(res.data.data));
};

export const insertMaterialData = async (data, config) => {
    return axios.post(API_INSERT_MATERIAL_DATA, data, config).then((res) => res.data);
};

export const updateMaterialData = async (data, config) => {
    return axios.put(API_UPDATE_MATERIAL_DATA, data, config).then((res) => res.data);
};